export enum ClickAbleTabsOnQuizHeader {
    QUIZMETADATA = "quizMetaData",
    QUIZROUNDS = "quizRounds",
    QUIZTEAMS = "quizTeams",
    QUIZSCORES = "quizScores"
}